<template>
  <div
    class="va-search"
    :class="{ 'va-search-desktop': !mobile }"
    role="button"
    tabindex="0"
    aria-label="O que você procura?"
    @click="$emit('select')"
    @keydown.enter.prevent="$emit('select')"
    @keydown.space.prevent="$emit('select')"
  >
    <v-icon color="primary">{{ _icon("magnify") }}</v-icon>
    <div class="va-search-text">
      <span class="va-search-title">O que você procura?</span>
      <span class="va-search-subtitle"
        >Explore todo o suporte indispensável para sua rotina clínica.</span
      >
    </div>
    <v-icon size="16" color="#8a97ab">{{ mdiChevronRight }}</v-icon>
  </div>
</template>

<style>
.va-search {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 14px;
  background: #f5f6fa;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.va-search:hover {
  background: #eef0f5;
}

.va-search-desktop {
  gap: 14px;
  padding: 18px 20px;
}

.va-search-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.va-search-title {
  font-size: 16px;
  line-height: 22px;
  color: #193153;
}

.va-search-desktop .va-search-title {
  font-size: 17px;
  line-height: 24px;
}

.va-search-subtitle {
  font-size: 12px;
  line-height: 16px;
  color: #6b7a90;
}

.va-search-desktop .va-search-subtitle {
  font-size: 13px;
  line-height: 18px;
}
</style>

<script>
import { mdiChevronRight } from "@mdi/js";

export default {
  name: "HomeSearchCard",
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mdiChevronRight,
    };
  },
};
</script>
